<div class="table-responsive">
    <table class="table">
        <thead>
            <tr>
                <th scope="col">Food</th>
                <th scope="col">Quantity</th>
                <th scope="col">Unit of Measure</th>
                <th scope="col">Alcohol</th>
                <th scope="col">Netcarbs</th>
                <th scope="col">Fat</th>
                <th scope="col">Protein</th>
                <th scope="col">Calories</th>
                <th scope="col">Deletes</th>
            </tr>
        </thead>
        <tbody class="table-group-divider">
            <ng-container *ngIf="(meals$ | async) as meals">
                <ng-container *ngIf="meals.length > 0; else noMeals">
                  @for(meal of meals; track $index){
                    <tr>
                            <td attr.data-testid="{{ mealType.toLowerCase() }}_food_name_{{ $index }}">{{meal.foodName}}</td>
                            <td>{{meal.quantity}}</td>
                            <td>{{meal.unitOfMeasure}}</td>
                            <td>{{meal.alcohol}}</td>
                            <td>{{meal.netcarbs}}</td>
                            <td>{{meal.fat}}</td>
                            <td>{{meal.protein}}</td>
                            <td>{{meal.calories}}</td>
                            <td>
                                <button attr.data-testid="{{ mealType.toLowerCase() }}_delete_btn_{{ $index }}" type="submit" class="btn btn-danger" title="Delete" (click)="deleteMeal(meal.mealId)">Delete</button>
                            </td>
                        </tr>
                  }
                </ng-container>
                <ng-template #noMeals>
                    <tr>
                        <td colspan="9">
                            <div attr.data-testid="{{ mealType.toLowerCase() }}_empty_plan_alert" class="alert alert-warning alert-dismissible fade show" role="alert">
                                <strong>Heads up!</strong> Your {{mealType.toLocaleLowerCase()}} plan is empty. Click the <strong>"Add Food to Plan"</strong> tab to add food to your
                                {{mealType.toLocaleLowerCase()}} plan.
                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </ng-container>
        </tbody>
    </table>
</div>
